export default "__VITE_ASSET__CCDjAzud__"